import { render } from "./live-delivery.vue?vue&type=template&id=5d2afd37&scoped=true"
import script from "./live-delivery.vue?vue&type=script&lang=js"
export * from "./live-delivery.vue?vue&type=script&lang=js"

import "./live-delivery.vue?vue&type=style&index=0&id=5d2afd37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2afd37"]])

export default __exports__